import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=5e1d2bdf&scoped=true&"
import script from "./CompanyInfo.vue?vue&type=script&lang=ts&"
export * from "./CompanyInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyInfo.vue?vue&type=style&index=0&id=5e1d2bdf&lang=less&scoped=true&"
import style1 from "./CompanyInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1d2bdf",
  null
  
)

export default component.exports